import axios from "axios";

export default {
    async setBarcode(dipendenteID: string, barcode: string) {
        const data = new FormData();
        data.append("dipendenti_badge_app", barcode);

        const response = await axios.post(`rest/v1/edit/dipendenti/${dipendenteID}`, data, {
            headers: {
                Authorization: process.env.VUE_APP_TOKEN,
            },
        });
        //console.log(response);
        return response.data;
    },

    async chiudiPresenza(dipendenteId, uscita, scope) {
        const data = new FormData();

        data.append("dipendente_id", dipendenteId);
        data.append("ora_uscita", uscita);
        data.append("scope", scope);

        //const response = await axios.post(`http://192.168.11.122/firegui_crm_h2/modulo-hr/app/timbraUscita`, data, {
        const response = await axios.post(`${process.env.VUE_APP_BASE_URL}modulo-hr/app/timbraUscita`, data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        //console.log(response);
        return response;
    },

    /**
     *
     * @param dipendenteID logged dipendente ID
     * @returns Dipendente badge in base64 to show personal QR
     */
    async getQrDipendente(dipendenteID: string) {
        //const response = await axios.get(`http://192.168.11.124/firegui_crm_h2/modulo-hr/qrcode/generateImage/null/false/false/${dipendenteID}`, {
        const response = await axios.get(`${process.env.VUE_APP_BASE_URL}modulo-hr/qrcode/generateImage/null/false/false/${dipendenteID}`, {
            headers: {
                Authorization: process.env.VUE_APP_TOKEN,
            },
        });
        //console.log(response);
        return response;
    },

    async getDipendenti() {
        const data = new FormData();
        data.append("dipendenti_attivo", "1");
        data.append("orderby", "dipendenti_cognome");
        data.append("orderdir", "asc");

        const response = await axios.post(`rest/v1/search/dipendenti`, data, {
            headers: {
                Authorization: process.env.VUE_APP_TOKEN,
            },
        });
        //console.log(response);
        return response;
    },

    async getDipendente(dipendentiId: string) {
        const response = await axios.get(`rest/v1/view/dipendenti/${dipendentiId}`, {
            headers: {
                Authorization: process.env.VUE_APP_TOKEN,
            },
        });
        //console.log(response);
        return response;
    },

    async uploadProfileImage(dipendenteID: string, base64: string) {
        const formData = new FormData();
        formData.append("dipendente", dipendenteID);
        formData.append("base64", base64);

        //const response = await axios.post(`http://192.168.11.159/firegui_crm_h2/modulo-hr/app/setProfileImage`, formData, {
        const response = await axios.post(`${process.env.VUE_APP_BASE_URL}modulo-hr/app/setProfileImage`, formData, {
            headers: {
                Authorization: process.env.VUE_APP_TOKEN,
            },
        });

        return response;
    },
};
